import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Header } from 'semantic-ui-react';
import CalculatorStore from '../../app/stores/calculatorStore';

const ApproximatePrice: React.FC = () => {
  const calculatorStore = useContext(CalculatorStore);
  const { currentPriceBRL, paymentInstallments, shipping, deliveryTimeDays } = calculatorStore;

  const style = {
    h3: {
      marginBottom: '0em',
      marginTop: '1em',
      padding: '2em 0em 0em 0em',
    },
    text_prazo: {
      color: '#5a5a5a',
    },
    h5: {
      marginTop: '1em',
      marginBottom: '1em',
      color: '#5a5a5a',
    },
  };

  return (
    <div>
      <Header
        as="p"
        content={`Custo aproximado ${currentPriceBRL}`}
        style={style.h3}
        textAlign="center"
      />

      {deliveryTimeDays !== '0' && (
        <Header
          as="p"
          style={style.text_prazo}
          content={`Prazo de ${deliveryTimeDays}*`}
          textAlign="center"
        />
      )}

      <Header
        as="h5"
        content={`ou em 3x de ${paymentInstallments} sem juros ${shipping}`}
        style={style.h5}
        textAlign="center"
      />
    </div>
  );
};

export default observer(ApproximatePrice);
